import axios from "axios";
import { getStoredToken, notifyExpiredSession } from "./authSession";

const resolveApiUrl = () => {
  const configuredApiUrl = (process.env.REACT_APP_API_URL || "").trim();

  if (!configuredApiUrl) return "/api";
  if (configuredApiUrl.startsWith("/")) return configuredApiUrl.replace(/\/+$/, "") || "/api";

  try {
    const apiUrl = new URL(configuredApiUrl);
    const path = apiUrl.pathname.replace(/\/+$/, "");

    if (!path) {
      apiUrl.pathname = "/api";
    }

    return apiUrl.toString().replace(/\/+$/, "");
  } catch {
    return configuredApiUrl;
  }
};

const API_URL = resolveApiUrl();

const http = axios.create({
  baseURL: API_URL,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

http.interceptors.request.use((config) => {
  const token = getStoredToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.data?.message && !error.response.data.error) {
      error.response.data.error = error.response.data.message;
    }

    const esPeticionLogin = /\/auth\/(login|verify-whatsapp)(?:[?#]|$)/.test(String(error.config?.url || ""));
    if (error.response?.status === 401 && !esPeticionLogin) {
      notifyExpiredSession();
    }

    return Promise.reject(error);
  },
);

export default http;
